import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressCookieBannerSettingsV1CookieBannerSettingsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'serverless.parastorage.com': [
      {
        srcPath: '/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'wixapis.com': [
      {
        srcPath: '/cookie-consent',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wixpress/cookie-banner-settings/v1/cookie-banner-settings',
        destPath: '/v1/cookie-banner-settings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/wixpress/cookie-banner-settings/v1/cookie-banner-settings',
        destPath: '/v1/cookie-banner-settings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressCookieBannerSettingsV1CookieBannerInstallationServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'serverless.parastorage.com': [
      {
        srcPath: '/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_serverless/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'wixapis.com': [
      {
        srcPath: '/cookie-consent',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/cookie-consent-settings-serverless',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wixpress/cookie-banner-settings/v1/cookie-banner-settings',
        destPath: '/v1/cookie-banner-settings',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/wixpress/cookie-banner-settings/v1/cookie-banner-settings',
        destPath: '/v1/cookie-banner-settings',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_consent-policy_cookie-banner-settings';

export function installCookieBanner(
  payload: object
): RequestOptionsFactory<any> {
  function __installCookieBanner({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'settings.expiryDate' }],
      },
    ]);
    const metadata = {
      entityFqdn:
        'wix.wixpress.cookie_banner_settings.v1.cookie_banner_settings',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cookie_banner_settings.v1.CookieBannerInstallationService.InstallCookieBanner',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCookieBannerSettingsV1CookieBannerInstallationServiceUrl(
        {
          protoPath: '/v1/cookie-banner-installation',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
    };

    return metadata;
  }

  return __installCookieBanner;
}

/** Retrieves the cookie banner settings. */
export function getCookieBannerSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __getCookieBannerSettings({ host }: any) {
    const metadata = {
      entityFqdn:
        'wix.wixpress.cookie_banner_settings.v1.cookie_banner_settings',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.cookie_banner_settings.v1.CookieBannerSettingsService.GetCookieBannerSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCookieBannerSettingsV1CookieBannerSettingsServiceUrl(
        { protoPath: '/v1/cookie-banner-settings', data: payload, host }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'settings.expiryDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __getCookieBannerSettings;
}

/** Updates the cookie banner settings. */
export function updateCookieBannerSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __updateCookieBannerSettings({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'settings.expiryDate' }],
      },
    ]);
    const metadata = {
      entityFqdn:
        'wix.wixpress.cookie_banner_settings.v1.cookie_banner_settings',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cookie_banner_settings.v1.CookieBannerSettingsService.UpdateCookieBannerSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCookieBannerSettingsV1CookieBannerSettingsServiceUrl(
        {
          protoPath: '/v1/cookie-banner-settings/update',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'settings.expiryDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __updateCookieBannerSettings;
}
